// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { useQuery } from '@tanstack/react-query';

import { useEnhancedRpcClient } from '~/hooks/useEnhancedRpc';

export function useGetAddressMetrics() {
	// safex_getLatestAddressMetrics is served by the indexer (/indexer), not the fullnode.
	const client = useEnhancedRpcClient();
	return useQuery({
		queryKey: ['home', 'addresses'],
		queryFn: () => client.getAddressMetrics(),
		gcTime: 24 * 60 * 60 * 1000,
		// Account totals move slowly (per-epoch) and the query is heavier; poll every 30s.
		staleTime: 30 * 1000,
		refetchInterval: 30 * 1000,
		retry: 5,
	});
}
